<template>
  <div class="mb-8">
    <container>
      <row>
        <column class="w-full">
          <main-title type="primary">
            {{ title }}
          </main-title>
        </column>
      </row>
    </container>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import { MainTitle } from '~/components/molecules'
import { Container, Row, Column } from '~/components/grid'

export default {
  components: {
    MainTitle,
    Container,
    Row,
    Column,
  },
  props: {
    title: VueTypes.string,
  },
}
</script>
